<template>
    <footer id="footer" class="footer style_1" v-if="originLoginType && mechanicCode != '705223' && !isGarden && !is_Sarrut && !is_Saga">
      <div class="widgets_row">
      <div class="footer_widgets">
        <div class="footer_logo">
          <a href="https://assur-camping-car.fr/" target="_blank">
            <img src="https://assur-camping-car.fr/wp-content/uploads/2018/11/LOGO-8.png" alt="assur-camping-car" width="286" height="53">
          </a>
        </div>
        <div class="footer_text">
          <ul class="icon-list-items">
            <li>
							<span class="icon-list-icon">
							<i aria-hidden="true" class="fa fa-phone-alt"></i>
							</span>
              <span class="icon-list-text">01 48 89 11 58</span>
            </li>
            <li>
							<span class="icon-list-icon">
							<i aria-hidden="true" class="fa fa-map"></i>						</span>
              <span class="icon-list-text">15 bd Voltaire<br>94210 La Varenne Saint-Hilaire</span>
            </li>
            <li class="icon-list-item">
											<span class="icon-list-icon">
							<i aria-hidden="true" class="fa fa-envelope"></i>						</span>
              <span class="icon-list-text"><a href="mailto:contact@assur-camping-car.fr" style="color:#FFF;">contact@assur-camping-car.fr</a>	</span>
            </li>
          </ul>

        </div>

        <div class="copyright_row">
          <div class="copyright_row_wr">
            <div class="socials">
              <ul>
                <li>
                  <a href="https://www.facebook.com/ASSUR-Camping-Car-104437814940143" target="_blank" class="social-facebook">
                    <i class="fa fa-facebook"></i>
                  </a>
                </li>
                <li>
                  <a href="https://twitter.com/AssurCar" target="_blank" class="social-twitter">
                    <i class="fa fa-twitter"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/company/assur-camping-car%20" target="_blank" class="social-google-plus">
                    <i class="fa fa-linkedin-in"></i>
                  </a>
                </li>
              </ul>
            </div>


          </div>
        </div>
      </div>
      <div class="footer_widgets">
        <div class="footer_logo">
          <a href="https://assur-garantiesmecaniques.fr/" target="_blank">
            <img src="https://assur-garantiesmecaniques.fr/wp-content/uploads/2020/03/logo_assur_garanties_mecaniques_blanc-8.png" alt="dynassurances" width="286" height="53">
          </a>
        </div>
        <div class="footer_text">
          <ul class="icon-list-items">
            <li>
							<span class="icon-list-icon">
							<i aria-hidden="true" class="fa fa-phone-alt"></i>
							</span>
              <span class="icon-list-text">01 48 89 57 57</span>
            </li>
            <li>
							<span class="icon-list-icon">
							<i aria-hidden="true" class="fa fa-map"></i>						</span>
              <span class="icon-list-text">15 bd Voltaire<br>94210 La Varenne Saint-Hilaire</span>
            </li>
            <li class="icon-list-item">
											<span class="icon-list-icon">
							<i aria-hidden="true" class="fa fa-envelope"></i>						</span>
              <span class="icon-list-text"><a href="mailto:contact@assur-garantiesmecaniques.fr" style="color:#FFF;">contact@assur-garantiesmecaniques.fr</a></span>
            </li>
          </ul>

        </div>

        <div class="copyright_row">
          <div class="copyright_row_wr">
            <div class="socials">
              <ul>
                <li>
                  <a href="https://www.facebook.com/ASSUR-Garanties-M%C3%A9caniques-104580318257450" target="_blank" class="social-facebook">
                    <i class="fa fa-facebook"></i>
                  </a>
                </li>
                <li>
                  <a href="https://twitter.com/AMecaniques" target="_blank" class="social-twitter">
                    <i class="fa fa-twitter"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/company/assur-garanties-m%C3%A9caniques" target="_blank" class="social-google-plus">
                    <i class="fa fa-linkedin-in"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="footer_widgets">
        <div class="footer_logo">
          <a href="https://www.dynassurances.fr/" target="_blank">
            <img src="https://www.dynassurances.fr/wp-content/uploads/2019/09/Arriere-plan.png" alt="dynassurances" width="286" height="53">
          </a>
        </div>
        <div class="footer_text">
          <ul class="icon-list-items">
            <li>
							<span class="icon-list-icon">
							<i aria-hidden="true" class="fa fa-phone-alt"></i>
							</span>
              <span class="icon-list-text">01 48 89 11 58</span>
            </li>
            <li>
							<span class="icon-list-icon">
							<i aria-hidden="true" class="fa fa-map"></i>						</span>
              <span class="icon-list-text">16, Rue de Turbigo <br>75002 paris</span>
            </li>
            <li class="icon-list-item">
											<span class="icon-list-icon">
							<i aria-hidden="true" class="fa fa-envelope"></i>					</span>
              <span class="icon-list-text"> <a href="mailto:contact@dynassurances.fr" style="color:#FFF;">contact@dynassurances.fr</a>	</span>
            </li>
          </ul>

        </div>

        <div class="copyright_row">
          <div class="copyright_row_wr">
            <div class="socials">
              <ul>
                <li>
                  <a href="https://www.facebook.com/Dynassurances/" target="_blank" class="social-facebook">
                    <i class="fa fa-facebook"></i>
                  </a>
                </li>
                <li>
                  <a href="https://twitter.com/dynassurances" target="_blank" class="social-twitter">
                    <i class="fa fa-twitter"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/company/dynassurances" target="_blank" class="social-google-plus">
                    <i class="fa fa-linkedin"></i>
                  </a>
                </li>
              </ul>
            </div>

          </div>
        </div>

      </div>
    </div>
      <br /><br />
      <div style="color: #fff; font-size: 12px;">Copyright 2005 - Développé par <a href="https://www.netgow.com/" target="_blank" style="color: #fff;">Netgow</a></div>
    </footer>
  <footer id="footer" class="footer style_1" v-else>
        <div class="widgets_row">
          <div class="footer_widgets">
          </div>
          <div class="footer_widgets" style="color: #fff; font-size: 12px;">
            Copyright 2005 - Développé par <a href="https://www.netgow.com/" target="_blank" style="color: #fff;">Netgow</a>
          </div>
        </div>
<!--        <span>-->
<!--            <a :href="GLOBAL_URL + 'contact.php'" target="_blank">Contactez-nous</a> |-->
<!--            <a :href="GLOBAL_URL + 'mentions-legales.php'" target="_blank">Mentions l&eacute;gales</a> |-->
<!--            <a :href="GLOBAL_URL + 'cgv.php'" target="_blank">Conditions g&eacute;n&eacute;rales de vente</a> |-->
<!--            <a :href="GLOBAL_URL + 'plan-dynassurances.php'" target="_blank">Plan du site</a>-->
<!--        </span>-->
<!--        <div class="scrixel">-->
<!--            <a href="http://www.netgow.com/" target="_blank">Cr&eacute;ation de site Internet</a> - -->
<!--            <strong>Netgow.com</strong>-->
<!--        </div>-->
    </footer>
</template>

<script>
    export default {
        name: 'Footer',
        data() {
            return {
                GLOBAL_URL: 'https://www.dynassurances.fr/'
            }
        },
        computed: {
          originLoginType() {
            return (this.$store.state.userInfo.origin_login === 'dynassurances') || (this.$store.state.userInfo.origin_login === 'assur_cc') || (this.$store.state.userInfo.origin_login === 'garanties_mechanics');
          },
          mechanicCode() {
            let code = (this.$store.state.userInfo && this.$store.state.userInfo.mechanic) ? this.$store.state.userInfo.mechanic.code : null;
            return code ? code : '';
          },
          isGarden() {
            return this.$store.getters.isGarden;
          },
          is_Sarrut() {
            return this.$store.state.userInfo.mechanic ? (this.$store.state.userInfo.mechanic.id == 4857) : false;
          },
          is_Saga() {
            return this.$store.state.userInfo.mechanic ? (this.$store.state.userInfo.mechanic.id == 4870) : false;
          }
        },
        methods: {},
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue